/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import * as React from 'react';
import { observer } from 'mobx-react';
import * as videojs from 'video.js';
import { IReportVideo } from 'Data';
import { ISingleVideoProps } from './ISingleVideoProps';

export interface SingleVideoState {
  chosenVideoAngle: IReportVideo;
}

@observer
export class SingleVideo extends React.Component<ISingleVideoProps, SingleVideoState> {
  private videoNode: HTMLVideoElement;
  private player: videojs.VideoJsPlayer;
  private isTm3VideoFormat: boolean;
  private speedFactor = 1;
  private videoFramerate = 30;

  private readonly videoOptions: videojs.VideoJsPlayerOptions = {
    preload: 'auto',
    controls: true,
    controlBar: {
      muteToggle: false,
      volumeControl: false,
      volumeMenuButton: false,
    },
  } as videojs.VideoJsPlayerOptions;

  constructor(props: ISingleVideoProps) {
    super(props, undefined);
    this.handleChooseVideoAngleClick = this.handleChooseVideoAngleClick.bind(this);
    const chosenVideoAngle = this.loadFromProps(this.props);
    this.state = { ...this.state, ...{ chosenVideoAngle } };
  }

  componentWillReceiveProps(nextProps: ISingleVideoProps) {
    const chosenVideoAngle = this.loadFromProps(nextProps);
    this.setState({ ...this.state, ...{ chosenVideoAngle } });
  }

  private loadFromProps(nextProps: ISingleVideoProps) {
    let chosenVideoAngle: IReportVideo = null;
    if (!nextProps.selectedVideo) {
      if (nextProps.defaultVideo) {
        chosenVideoAngle = nextProps.defaultVideo;
      } else if (nextProps.videos && nextProps.videos.length > 0) {
        chosenVideoAngle = nextProps.videos[0];
      }
    } else {
      chosenVideoAngle = nextProps.selectedVideo;
    }

    if (chosenVideoAngle.metaData !== null && chosenVideoAngle.metaData.speedFactor) {
      this.speedFactor = chosenVideoAngle.metaData.speedFactor;
    }
    //If the video comes from the TM3 format, it will have a value similar to "data:image/mp4;base64,", so here it is best to check for the match at the beginning of the phrase
    const regexForTps = /^data/;
    this.isTm3VideoFormat = regexForTps.test(chosenVideoAngle.url);
    if (!this.isTm3VideoFormat) {
      //If the video comes from the TM3 format in IOS it will have a string in the uri that contains the following "type=tm3"
      const regexForIOS = /type=tm3e/;
      this.isTm3VideoFormat = regexForIOS.test(chosenVideoAngle.url);
    }

    return chosenVideoAngle;
  }

  private customazieVideoControls() {
    const MenuItem = (videojs as any).getComponent('MenuItem');
    const Menu = (videojs as any).getComponent('Menu');
    const video = this.state.chosenVideoAngle;
    const player = this.player;

    const MyPlaybackRateMenuItem = (videojs as any).extend(MenuItem, {
      constructor: function(player, options) {
        const label = options.label;
        const rate = parseFloat(options.rate);

        options.label = label;
        options.selected = label === '1:1';
        options.selectable = true;

        MenuItem.apply(this, arguments); //call super()

        this.label = label;
        this.rate = rate;
        this.on(player, 'ratechange', this.update);
      },
      handleClick: function() {
        MenuItem.prototype.handleClick();
        video.selectedVideoSpeedRate = this.rate;
        player.playbackRate(video.selectedVideoSpeedRate);
      },
      update: function() {
        //console.log("update", this.player().playbackRate(), this.rate);
        this.selected(this.player().playbackRate() === this.rate);
      },
    });

    //http://docs.(videojs as any).com/control-bar_playback-rate-menu_playback-rate-menu-button.js.html
    const MenuButton = (videojs as any).getComponent('MenuButton');

    const MyPlaybackRateMenuButton = (videojs as any).extend(MenuButton, {
      constructor: function(player) {
        // It is important to invoke the superclass before anything else, to get all the features of components out of the box!
        MenuButton.apply(this, arguments);

        this.updateVisibility();
        this.updateLabel();

        this.on(player, 'loadstart', this.updateVisibility);
        this.on(player, 'ratechange', this.updateLabel);
      },
      createEl: function() {
        const el = MenuButton.prototype.createEl.call(this);

        this.labelEl_ = (videojs as any).createEl('div', {
          // Prefixing classes of elements within a player with "vjs-" is a convention used in Video.js.
          className: 'vjs-playback-rate-value',
          innerHTML: 1.0,
        });

        el.appendChild(this.labelEl_);
        return el;
      },
      buildCSSClass: function() {
        return `vjs-playback-rate ${MenuButton.prototype.buildCSSClass.call(this)}`;
      },
      buildWrapperCSSClass: function() {
        return `vjs-playback-rate ${MenuButton.prototype.buildWrapperCSSClass.call(this)}`;
      },
      createMenu: function() {
        const menu = new Menu(this.player());
        const rates = this.playbackRates();
        if (rates) {
          for (let i = rates.length - 1; i >= 0; i--) {
            menu.addChild(
              new MyPlaybackRateMenuItem(this.player(), {
                rate: rates[i].rate,
                label: rates[i].label,
              })
            );
          }
        }
        return menu;
      },
      updateARIAAttributes: function() {
        this.el().setAttribute('aria-valuenow', this.player().playbackRate());
      },
      handleClick: function() {
        //const currentRate = this.player().playbackRate();
        //const rates = this.playbackRates();
        //let newRate = rates[0].rate;
        //for (let i = 0; i < rates.length; i++) {
        //    if (rates[i].rate > currentRate) {
        //        newRate = rates[i].rate;
        //        break;
        //    }
        //}
        //this.player().playbackRate(newRate);
      },
      playbackRates: function() {
        let idx = 0;
        let readOptions = true;
        const options = [];
        while (readOptions) {
          if (this.options_[idx]) {
            options.push(this.options_[idx]);
            idx++;
          } else {
            readOptions = false;
          }
        }
        return options;
      },
      playbackRateSupported: function() {
        return (
          this.player().tech_ &&
          this.player().tech_.featuresPlaybackRate &&
          this.playbackRates() &&
          this.playbackRates().length > 0
        );
      },
      updateVisibility: function() {
        if (this.playbackRateSupported()) {
          this.removeClass('vjs-hidden');
        } else {
          this.addClass('vjs-hidden');
        }
      },
      updateLabel: function() {
        const rates = this.playbackRates();
        let label = rates[0].label;
        const currentRate = this.player().playbackRate();
        for (let i = 0; i < rates.length; i++) {
          if (rates[i].rate === currentRate) {
            label = rates[i].label;
            break;
          }
        }
        this.labelEl_.innerHTML = label;
      },
    });

    (videojs as any).registerComponent('MyPlaybackRateMenuItem', MyPlaybackRateMenuItem);
    (videojs as any).registerComponent('MyPlaybackRateMenuButton', MyPlaybackRateMenuButton);

    (this.player as any).controlBar.addChild('MyPlaybackRateMenuButton', [
      { rate: this.speedFactor, label: '1:1' },
      { rate: this.speedFactor / 2, label: '1:2' },
      { rate: this.speedFactor / 4, label: '1:4' },
      { rate: this.speedFactor / 8, label: '1:8' },
    ]);

    this.player.playbackRate(this.speedFactor);

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    if (!this.props.isTps) {
      const videojsButton = (videojs as any).getComponent('Button');
      const myButtonSSF = (videojs as any).extend(videojsButton, {
        constructor: function() {
          videojsButton.call(this, player);
        },
        handleClick: () => {
          if (!player.paused()) {
            player.pause();
          }
          player.currentTime(player.currentTime() + 1 / self.videoFramerate);
        },
      });
      const myButtonSSB = (videojs as any).extend(videojsButton, {
        constructor: function() {
          videojsButton.call(this, player);
        },
        handleClick: () => {
          if (!player.paused()) {
            player.pause();
          }
          player.currentTime(player.currentTime() - 1 / self.videoFramerate);
        },
      });

      if (!this.videoNode.querySelector('.vjs-single-step-forward')) {
        //add single step backward button
        const myButtonSsbInstnce = (player as any).controlBar.addChild(new myButtonSSB());
        myButtonSsbInstnce.addClass('vjs-single-step-backward');

        //add single step forward button
        const myButtonSSFInstnce = (player as any).controlBar.addChild(new myButtonSSF());
        myButtonSSFInstnce.addClass('vjs-single-step-forward');

        const forwardEl = document.createElement('span');
        const backwardEl = document.createElement('span');
        forwardEl.setAttribute('aria-hidden', 'true');
        backwardEl.setAttribute('aria-hidden', 'true');
        forwardEl.className = 'glyphicon glyphicon-step-forward';
        backwardEl.className = 'glyphicon glyphicon-step-backward';

        const parentNode = this.videoNode.parentNode as HTMLElement;
        if (parentNode) {
          parentNode.querySelector('.vjs-single-step-forward').appendChild(forwardEl);
          parentNode.querySelector('.vjs-single-step-backward').appendChild(backwardEl);
        }
      }
    }
  }

  private setupPlayer(playerNode: any) {
    // instantiate Video.js
    if (this.player) return;
    this.videoNode = playerNode || this.videoNode;
    this.player = (videojs as any)(this.videoNode, this.videoOptions);
    this.customazieVideoControls();
  }

  handleChooseVideoAngleClick(video: IReportVideo): void {
    this.setState({ chosenVideoAngle: video }, () => {
      this.player?.src(video.url);
      this.player?.poster(video.posterUrl);
      const myPlaybackRateMenuButton = (this.player as any).controlBar
        .children()
        .filter(child => (child as any).name() === 'MyPlaybackRateMenuButton');
      (myPlaybackRateMenuButton[0] as any)?.updateLabel();
    });
    this.props.onSelectedVideoChanged && this.props.onSelectedVideoChanged(video);
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    const chosenVideoAngle = this.state.chosenVideoAngle;
    return (
      <div>
        {this.props.showChangeAnglesButton && (
          <div className={'camera-angles' + (this.props.alignRight ? ' align-right' : '')}>
            <div className="camera-angles-btn">
              <span className="camera-angle-text">Camera Angle</span>
            </div>
            <div
              className={
                'video-angles display-angle' +
                (this.props.alignRight ? ' align-right-with-float' : '')
              }
            >
              {this.props.videos.map((video, index) => (
                <span
                  key={video.id}
                  className={
                    'single-angle' + (video.id === chosenVideoAngle.id ? ' selected-angle' : '')
                  }
                  onClick={(() => this.handleChooseVideoAngleClick(video)).bind(this)}
                >
                  {index + 1}
                </span>
              ))}
            </div>
          </div>
        )}
        {this.props.isTps && this.isTm3VideoFormat && (
          <div className="image-container">
            <img src={chosenVideoAngle.posterUrl} />
            <div className="info-container-tm-three-video">
              <p>The video cannot be played.</p>
              <p>It will be possible as soon as shown online.</p>
            </div>
          </div>
        )}
        <video
          ref={node => this.setupPlayer(node)}
          className="video-js vjs-default-skin vjs-big-play-centered"
          id={'videoPlayer-' + this.props.alignRight}
          poster={chosenVideoAngle.posterUrl}
          data-setup={'{"controls": true, "preload": "auto" }'}
        >
          <source src={chosenVideoAngle.url} type="video/mp4" />
          <p className="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser
            that{' '}
            <a
              href="http://(videojs as any).com/html5-video-support/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              supports HTML5 video
            </a>
          </p>
        </video>
      </div>
    );
  }
}
